<template>
  <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" class="double-circle-progress">
    <!-- 背景圆环（外圈） -->
    <circle
      class="background-ring"
      :stroke="bgColor"
      :stroke-width="strokeWidth"
      :r="outerRadius"
      :cx="center"
      :cy="center"
      fill="none"
    />
    <!-- 背景圆环（内圈） -->
    <circle
      class="background-ring-inner"
      :stroke="bgColor"
      :stroke-width="strokeWidth"
      :r="innerRadius"
      :cx="center"
      :cy="center"
      fill="none"
    />
    <!-- 外圈进度 -->
    <circle
      class="outer-ring"
      :stroke="color1"
      :stroke-width="strokeWidth"
      :r="outerRadius"
      :cx="center"
      :cy="center"
      fill="none"
      :stroke-dasharray="outerCircumference"
      :stroke-dashoffset="outerDashoffset"
      stroke-linecap="round"
      :transform="`rotate(-90 ${center} ${center})`"
    />
    <!-- 内圈进度 -->
    <circle
      class="inner-ring"
      :stroke="color2"
      :stroke-width="strokeWidth"
      :r="innerRadius"
      :cx="center"
      :cy="center"
      fill="none"
      :stroke-dasharray="innerCircumference"
      :stroke-dashoffset="innerDashoffset"
      stroke-linecap="round"
      :transform="`rotate(-90 ${center} ${center})`"
    />
  </svg>
</template>

<script>
export default {
  name: 'DoubleCircleProgress',
  props: {
    size: {
      type: Number,
      default: 120,
    },
    strokeWidth: {
      type: Number,
      default: 10,
    },
    value1: {
      type: Number,
      default: 0,
      validator: v => v >= 0 && v <= 100
    },
    value2: {
      type: Number,
      default: 0,
      validator: v => v >= 0 && v <= 100
    },
    color1: {
      type: String,
      default: 'var(--ek-color-primary)'
    },
    color2: {
      type: String,
      default: '#f300ffbf'
    },
    bgColor: {
      type: String,
      default: '#eee'
    }
  },
  computed: {
    center() {
      return this.size / 2;
    },
    outerRadius() {
      // 外圈半径，减去半个描边宽以防描边超出SVG边界
      return this.center - this.strokeWidth / 2;
    },
    innerRadius() {
      // 内圈半径，确保与外圈有间距
      return this.outerRadius - this.strokeWidth - 10; // 6是间距，可以调整
    },
    outerCircumference() {
      return 2 * Math.PI * this.outerRadius;
    },
    innerCircumference() {
      return 2 * Math.PI * this.innerRadius;
    },
    outerDashoffset() {
      return this.outerCircumference * (1 - this.value1 / 100);
    },
    innerDashoffset() {
      return this.innerCircumference * (1 - this.value2 / 100);
    }
  }
}
</script>

<style scoped>
.double-circle-progress {
  display: block;
  margin: auto;
}

/* 背景圆环颜色 */
.background-ring, .background-ring-inner {
  opacity: 0.2;
}

/* 进度圆环动画 */
.outer-ring,
.inner-ring {
  transition: stroke-dashoffset 0.3s ease;
}
</style>
